export enum UserRole {
  Anonymous = 'anonymous',
  Admin = 'admin',
  Tester = 'tester',
  Customer = 'customer',
  Viewer = 'viewer'
}
